import { MobileNavOptions } from '@quark/header'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { DropDownTypes, MobileCategoryTypes, NavModes } from '@enums/QuarkHeader'
import { getIcon } from '@configs/quarkIcons.config'
import TravelPass from '@components/HomeHeader/banners/travel-pass'
import UserStory from '@components/HomeHeader/banners/user-story'

export const openLink = (headerName: string, tabNameList: string[], url: string, openInNewTab: boolean = true) => {
  void trackEvent('tap_header_tabs', {
    header_name: headerName,
    page_type: 'seo',
    tab_names: tabNameList,
    redirection_url: url,
  })

  if (!url) return

  if (openInNewTab) {
    window.open(url, '_blank', 'noopener,noreferrer')
  } else {
    window.location.href = url
  }
}

export const getSectionData = (section, parent, dropDownType) => {
  if (section?.isExpandable) {
    if (dropDownType === DropDownTypes?.FullWidth) {
      return {
        name: section?.title,
        isExpandable: section?.isExpandable,
        props: { onClick: () => openLink(section?.title, [parent, section?.title], '') },
        icon: getIcon(section?.iconComponent),
        options: section?.sectionOptions?.map(option => ({
          name: option?.title,
          isExpandable: false,
          props: {
            onClick: () => openLink(option?.title, [parent, section?.title], option?.desktopUrl),
          },
          icon: getIcon(option?.iconComponent),
        })),
      }
    }

    return {
      heading: section?.title,
      options: section?.sectionOptions?.map(option => ({
        name: option?.title,
        isExpandable: false,
        props: {
          onClick: () => openLink(option?.title, [parent, section?.title], option?.desktopUrl),
        },
        icon: getIcon(option?.iconComponent),
      })),
    }
  }

  return {
    name: section?.title,
    isExpandable: section?.isExpandable,
    icon: getIcon(section?.redirectionData?.iconComponent),
    props: {
      onClick: () => openLink(section?.title, [parent, section?.title], section?.redirectionData?.desktopUrl),
    },
  }
}

export const getModifiedSectionData = (categories: any) => {
  const modifiedCategories = categories.reduce((acc, category) => {
    if (category?.navMode !== NavModes?.REDIRECT || category?.redirectionData?.desktopUrl) {
      acc.push({
        name: category?.title,
        isExpandable: category?.navMode !== NavModes?.REDIRECT,
        dropDownType: category?.dropDownType,
        type: category?.navMode,
        props: {
          onClick: () => openLink(category?.title, [category?.title], category?.redirectionData?.desktopUrl || ''),
        },
        options: category?.categorySections?.map(section =>
          getSectionData(section, category?.title, category?.dropDownType)
        ),
        banner: category?.bannerProps?.bannerType === 'travel-pass' ? <TravelPass /> : <UserStory />,
      })
    }
    return acc
  }, [])
  return modifiedCategories
}

const getType = (navMode, dropDownType, len) => {
  if (navMode === NavModes?.REDIRECT) return MobileCategoryTypes?.LINK
  if (dropDownType === DropDownTypes?.FullWidth) {
    if (len && len > 0) return MobileCategoryTypes?.ACCORDION
    return MobileCategoryTypes?.MIXED
  }
  return MobileCategoryTypes?.MIXED
}

const getAccordionSectionData = (section, parent) => ({
  name: section?.mobileTitle || section?.title,
  type: MobileCategoryTypes?.ACCORDION,
  icon: section?.redirectionData?.darkBgImageUrl || section?.darkBgImageUrl,
  props: {
    onClick: () =>
      openLink(
        section?.mobileTitle || section?.title,
        [parent],
        section?.redirectionData?.mobileUrl || section?.mobileUrl || ''
      ),
  },
  options: section?.sectionOptions?.map(option => ({
    name: option?.title,
    type: MobileCategoryTypes?.LINK,
    props: {
      onClick: () => openLink(option?.title, [parent, section?.mobileTitle], option?.mobileUrl),
    },
  })),
})

const getAllSectionData = (categorySections, parent, type): any => {
  if (type === MobileCategoryTypes?.MIXED && categorySections?.[0]?.sectionOptions?.length > 0) {
    return categorySections?.[0]?.sectionOptions?.map(section => getAccordionSectionData(section, parent))
  }
  return categorySections?.map(section => getAccordionSectionData(section, parent))
}

export const getModifiedOptions = (content: any): MobileNavOptions[] => {
  const newCategoriesList = [...(content?.leftSideCategories || []), ...(content?.rightSideCategories || [])].sort(
    (a, b) => a.priority - b.priority
  )
  return newCategoriesList?.map(category => {
    const type = getType(
      category?.navMode,
      category?.dropDownType,
      category?.categorySections?.[0]?.sectionOptions?.length
    )
    return {
      name: category?.title,
      isExpandable: category?.navMode !== NavModes?.REDIRECT,
      type,
      props: {
        onClick: () => openLink(category?.title, [category?.title], category?.redirectionData?.mobileUrl || ''),
      },
      options: getAllSectionData(category?.categorySections, category?.title, type),
    }
  })
}
